import { useMemo, useState } from "react";
import { useParams } from "react-router";
import { Job, JobList, JobService } from "./Api";
import JobContext from "./JobContext";
import { JobProviderState } from "./JobProviderState";
import { useQuery } from "./Utils";

const initState = {
    isLoading: true,
    jobList: {} as JobList,
    job: {} as Job,
} as JobProviderState;

export const JobProvider = ({ children }) => {
    const { tenant, listName, id } = useParams();
    const [state, setState] = useState<JobProviderState>(initState);
    const query = useQuery();
    const previewMode = query.get("preview") !== null && query.get("preview") === "true";

    const getJob = async () => {
        try {
            const result = await JobService.getJob(tenant, listName, id, previewMode);
            const jobList: JobList = result;
            const job: Job = jobList.jobs[0];

            const newState = {
                isLoading: false,
                jobList: jobList,
                job: job,
                error: null,
            } as JobProviderState;
            console.debug(newState);
            setState(newState);
        } catch (error) {
            const message = "Fehler beim Laden";
            let description = "Stellenanzeige konnte nicht geladen werden";
            if (error === 410) {
                description = "Stellenanzeige ist deaktiviert oder liegt außerhalb des Veröffentlichungszeitraums."
            }
            if (error === 404) {
                description = "Es konnte keine Stellenausschreibung zum angegebenen Stellenlink gefunden werden."
            }
            const newState = {
                isLoading: false,
                error: { message: message, description: description }
            } as JobProviderState;
            setState(newState);
        }

    };

    const memo = useMemo(() => (state), [state]);

    if (memo.isLoading) getJob();

    return (
        <JobContext.Provider value={state} >
            {children}
        </JobContext.Provider>
    );
}